import {createBrowserHistory} from "history";

const history = createBrowserHistory();

const createHistory = () => history;

export { history, createHistory };
